/**
 * On Estrella side:
 * There are 2 types of invitations - `Invited` and `Requested`
 * and both can have status `Pending` (if not accepted yet by mainteiner or endUser).
 *
 *
 * On Vitoguide side:
 * There are 2 main types of invitations - ``Incoming`` and ``Pending``
 * and both have Estrella status `Pending`
 *
 * Vitoguide ``Incoming`` invitations mean invitations with Estrella status `Pending` and token type `Invited`
 * (maintainer is invited by end user and invitation is waitnig to be accepted or rejected by him)
 *
 * Vitoguide ``Pending`` invitations mean invitations also with Estrella status `Pending` but with token type `Requested`
 * (maintainer sent invitation to an end user/requested access to an installation and he is waiting for accepting or
 * rejecting that invitation)
 */

import {
  Invitation,
  InvitationAccessLevel,
  InvitationStatusType,
  ListResponse,
} from '@vi-iot/client';

export enum ActiveInvitationsFilterType {
  All = 'all',
  Incoming = 'incoming',
  Pending = 'pending',
  Declined = 'declined',
  Expired = 'expired',
}

export interface InvitationPayloadWrapper {
  properties: Invitation;
}

export interface BulkListInvitationsCombinedResponses {
  pendingInvitations: ListResponse<Invitation>;
  expiredInvitations: ListResponse<Invitation>;
  rejectedInvitations: ListResponse<Invitation>;
  acceptedInvitations: ListResponse<Invitation>;
  canceledInvitations: ListResponse<Invitation>;
  terminatedInvitations: ListResponse<Invitation>;
  userId: string;
  buildingManagerInvitations: Invitation[];
}
export interface BulkInvitations {
  pending: ListResponse<Invitation>;
  expired: ListResponse<Invitation>;
  declined: ListResponse<Invitation>;
  accepted: ListResponse<Invitation>;
  canceled: ListResponse<Invitation>;
  terminated: ListResponse<Invitation>;
}

export interface CommunicationModuleInvitations {
  data: Invitation[];
  paging: Paging;
}

export interface Paging {
  offset: number;
  limit: number;
  total: number;
}

export interface BulkInvitations {
  pending: ListResponse<Invitation>;
  expired: ListResponse<Invitation>;
  declined: ListResponse<Invitation>;
  accepted: ListResponse<Invitation>;
  canceled: ListResponse<Invitation>;
  terminated: ListResponse<Invitation>;
  userId: string;
  companyId: string;
}
export interface InstallationInvitationToUpdate {
  token: string;
  status: InvitationStatusType;
}
export interface InstallationInvitationToCreate {
  installationId: string | number;
  inviteeEmail: string;
  accessLevel: InvitationAccessLevel;
}

export interface BulkSaveBuildingMangerInvitationsPayload {
  invitationsToUpdate: InstallationInvitationToUpdate[];
  invitationsToCreate: InstallationInvitationToCreate[];
}
